import React from "react";

// Components
import { IonItem, IonLabel } from "@ionic/react";
import { withTranslation } from "react-i18next";
import InputFactory from "../../components/Factories/Input/InputFactory";

class FormDetails extends React.Component<any, any> {
  render() {
    const { form, t } = this.props;

    return (
      <div className="form-list__form__item">
        <IonItem>
          <IonLabel position={"stacked"}>{t("name")}</IonLabel>
          <InputFactory disabled={true} value={form.name} type={"text"} placeholder={t("nameOfForm")} />
        </IonItem>
        <IonItem>
          <IonLabel position={"stacked"}>{t("formHandler")}</IonLabel>
          <InputFactory disabled={true} value={form.handler} type={"text"} placeholder="eg: https://wearesweet.co.uk/belong" />
        </IonItem>
        <div style={{ display: "flex" }}>
          <IonItem style={{ width: "100%" }}>
            <IonLabel position={"stacked"}>{t("enabled")}</IonLabel>
            <InputFactory disabled={true} checked={form.enabled} type={"checkbox"} />
          </IonItem>
          <IonItem style={{ width: "100%" }}>
            <IonLabel position={"stacked"}>{t("requiresVerification")}</IonLabel>
            <InputFactory disabled={true} checked={form.requires_verification} type={"checkbox"} />
          </IonItem>
        </div>
      </div>
    );
  }
}

export default withTranslation()(FormDetails);
